import { useMemo, useState } from "react";
import { IconClipboardText } from "@tabler/icons-react";
import CmsLayout from "@layouts/CmsLayout";
import OnBoardingTabs from "@components/on_boarding/OnBoardingTabs";
import ContentSection from "@components/on_boarding/sections/ContentSection";
import "@assets/css/tour/add.css";
import "@assets/css/home_content/panel.css";
import "@assets/css/on_boarding/panel.css";

const ON_BOARDING_TABS = [
  { id: "content", label: "Content", Icon: IconClipboardText },
];

const ON_BOARDING_VIEW_BY_TAB = {
  content: ContentSection,
};

function OnBoardingPage() {
  const [activeTab, setActiveTab] = useState(ON_BOARDING_TABS[0].id);
  const ActiveSection = useMemo(
    () => ON_BOARDING_VIEW_BY_TAB[activeTab] || ContentSection,
    [activeTab],
  );

  return (
    <CmsLayout activeModule="on-boarding" title="On Boarding">
      <section className="panel table-panel on-boarding-panel">
        <div className="on-boarding-panel-inner">
          <div className="index-table-bar on-boarding-panel-head">
            <div>
              <h2>On Boarding</h2>
            </div>
          </div>

          <OnBoardingTabs
            tabs={ON_BOARDING_TABS}
            activeTab={activeTab}
            onTabChange={setActiveTab}
          />

          <div className="on-boarding-panel-body">
            <ActiveSection />
          </div>
        </div>
      </section>
    </CmsLayout>
  );
}

export default OnBoardingPage;
